import { render } from "./farm-table.vue?vue&type=template&id=032748e5&scoped=true"
import script from "./farm-table.vue?vue&type=script&lang=js"
export * from "./farm-table.vue?vue&type=script&lang=js"

import "./farm-table.vue?vue&type=style&index=0&id=032748e5&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032748e5"]])

export default __exports__